export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__text">
        <section className="hero__text__intro">
          <div className="flex__container">
            <h1>Har du mistet lidt af dig selv undervejs?</h1>
            <p className="hero__text__intro__p">
              Måske er du blevet rigtig god til at være der for alle andre.<br />
              Til at tilpasse dig, holde sammen på tingene og mærke, hvad andre har brug for — men har sværere ved at mærke dig selv. <br />
              Måske har du oplevet svigt, traumer eller tab, der har gjort dig mere forsigtig og mindre modig. <br />
              Måske har du svært ved at mærke din egen lyst, seksualitet eller grænser. <br />  
              Måske længes du efter mere selvværd, frihed, kærlighed, lyst eller mod til faktisk at leve det liv, der føles rigtigt for dig. <br /> 
              Det er noget af det, jeg elsker allermest at arbejde med. <br />
              Jeg tilbyder individuel terapi, sexologisk rådgivning og parterapi — men mit arbejde handler ikke kun om at løse problemer. <br />
              Det handler også om at finde hjem i sig selv. <br />
              Om at turde fylde. Sætte grænser. <br />
              Mærke sin krop og sin intuition. Give slip på gamle mønstre og relationer, der gør én mindre. Og begynde at stole mere på den, man faktisk er. <br />
              Særligt arbejdet med kvinder, selvværd og empowerment ligger mit hjerte meget nært. <br />
              Jeg er selv meget spirituelt funderet og arbejder med en stærk tro på intuition, energi og den forbindelse, vi har til os selv og til noget større end os. For mig kan terapi derfor både være jordnær og konkret — og samtidig give plads til det spirituelle, når det giver mening for dig. <br />

              
            </p>
          </div>
          
          <div className="flex__container">
            <img src="/amaliePhoto.jpg" alt="Amalie" />
            <h1> Du kan blandt andet komme til mig, hvis du: </h1>
            <ul>
              <li>bliver ved med at ende i de samme relationelle mønstre</li>
              <li>tvivler på dig selv eller har svært ved at mærke dine egne behov</li>
              <li>længes efter mere selvværd og styrke</li>
              <li>vil blive bedre til at sætte grænser uden dårlig samvittighed</li>
              <li>oplever kropsskam, seksuel usikkerhed eller manglende lyst</li>
              <li>står i dating, utroskab, brud eller en stor livsforandring</li>
              <li>savner nærhed og forbindelse i dit parforhold</li>
              <li>eller bare kan mærke, at noget i dig vil mere</li>
            </ul>
          </div>
          
        </section>
        <section className="hero__text__contact">
          <h1>Kontakt</h1>
          <p className="hero__text__contact__p">
          Du behøver ikke vide præcis, hvad du skal sige, når du kommer. Du behøver heller ikke have regnet dig selv ud på forhånd. <br />

          Vi starter dér, hvor du er. <br/>

          Jeg er certificeret sexolog og har desuden 10 års erfaring som socialpædagog. Jeg arbejder med mennesker uanset køn, seksualitet og kønsidentitet — og tilbyder også parterapi og terapi på engelsk.

          Online terapi er også muligt. <br />

          Er du nysgerrig på, om jeg kunne være den rette for dig? Så skriv til mig på: <br/>  

          <a href="mailto:Dinsexolog@yahoo.com">Dinsexolog@yahoo.com</a> <br/>

           Du behøver ikke formulere en lang historie — et enkelt “hej, jeg vil gerne høre mere” er rigeligt.
          </p>

          <p>Jeg holder til på:</p>
          <a href="https://www.google.com/maps/dir/?api=1&destination=Kroghsgade+1,+1.+tv.,+2100+København+Ø">Kroghsgade 1, 1. tv., 2100 København Ø</a>

        </section>
        
      </div>
    </section>
  );
}